import React from "react";
import "./PageTitleBadge.css";

/**
 * Composant réutilisable pour le badge de titre des pages
 * @param {string} title - Le titre à afficher
 * @param {ReactNode} icon - L'icône à afficher (ex: <GiCow />)
 */
export default function PageTitleBadge({ title, icon }) {
  return (
    <div className="title-badge">
      {icon && <span className="page-title-icon">{icon}</span>}
      <span>{title}</span>
    </div>
  );
}

